// Woningvorm options for the standardized "Type woning" data field on the
// Gegevens tab (requested by gemeente Hilversum, 2026-08).
export const WONINGVORM_OPTIONS = [
    'Appartement',
    'Eindwoning',
    'Tussenwoning',
    'Vrijstaand',
    '2-onder-1 kap',
];

// Options for the select, keeping an already-stored non-standard value (e.g.
// "koop" from an old intake) selectable instead of silently dropping it.
const housingTypeOptions = (currentValue) => {
    if (currentValue && !WONINGVORM_OPTIONS.includes(currentValue)) {
        return [currentValue, ...WONINGVORM_OPTIONS];
    }
    return [...WONINGVORM_OPTIONS];
};

export default housingTypeOptions;
